import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import YouTubeIcon from "@material-ui/icons/YouTube";
import { HelpOutline } from "@mui/icons-material";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppService } from "../../../../service/app_sevice/AppService";

const IndicationCreationCompte = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleDownload = () => {
    setLoading(true);
    AppService.downloadUserGuid()
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "guide.pdf");
        document.body.appendChild(link);
        link.click();
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      <Alert
        variant="outlined"
        severity="info"
        sx={{
          borderRadius: 4,
          border: "1px solid #90caf9",
          backgroundColor: "rgba(231, 243, 255, 0.6)",
          p: 3,
          "& .MuiAlert-icon": {
            fontSize: "2rem",
            color: "#1976d2",
          },
        }}
      >
        <AlertTitle sx={{ fontSize: "1.2rem", mb: 2 }}>
          <b>Indication</b>
        </AlertTitle>
        <Typography variant="body1" sx={{ color: "#333", mb: 2 }}>
          Pour pouvoir postuler à un offre, vous devez d’abord disposer d’un
          compte.
        </Typography>
        <Typography
          variant="body2"
          component="ul"
          sx={{ color: "#555", mb: 2, paddingLeft: 2 }}
        >
          <li style={{ marginBottom: "8px" }}>
            Si vous n’avez pas encore de compte, veuillez en créer un.
          </li>
          <li style={{ marginBottom: "8px" }}>
            Lors de l’inscription, choisissez le type de compte correspondant à
            votre statut :
            <Box
              component="ul"
              sx={{ mt: 1, paddingLeft: 2, listStyleType: "circle" }}
            >
              <li>
                <b>Consultant Individuel</b>
              </li>
              <li>
                <b>Volontaire</b>
              </li>
              <li>
                <b>AGEX/Cabinet/Association</b>
              </li>
            </Box>
          </li>
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Typography
            variant="body2"
            sx={{ color: "#555", mb: 2, fontWeight: "bold" }}
          >
            Consultez les guides d'utilisation ci-dessous
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
            <Button
              variant="contained"
              size="small"
              color="error"
              startIcon={<YouTubeIcon />}
              href="https://youtu.be/ICpzFL5JWhM"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                textTransform: "none",
                borderRadius: 2,
                fontWeight: "bold",
              }}
            >
              Version vidéo
            </Button>
            <Button
              size="small"
              loading={loading}
              variant="outlined"
              color="primary"
              startIcon={<PictureAsPdfIcon />}
              onClick={handleDownload}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                fontWeight: "bold",
              }}
            >
              Version PDF
            </Button>
            <IconButton onClick={(e) => navigate("/aide")} title="Guide d'utilisation">
              <HelpOutline />
            </IconButton>
          </Stack>
        </Box>
      </Alert>
    </>
  );
};

export default IndicationCreationCompte;
